// extracted by mini-css-extract-plugin
export default {"pageHiddenAlertContainer":"PageHiddenAlert_pageHiddenAlertContainer__3aMQN","pageHiddenAlert":"PageHiddenAlert_pageHiddenAlert__YVIJ8"};